// client/src/pages/secure/TransactionListPage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApiClient } from '../../hooks/useApiClient';
import DataList from '../../components/shared/DataList';
import PageHeader from '../../components/shared/PageHeader';

const TransactionListPage = () => {
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiClient = useApiClient();

    useEffect(() => {
        apiClient.get('/api/transactions')
            .then(data => setTransactions(data))
            .catch(err => setError(err.message || 'Failed to fetch transactions.'))
            .finally(() => setIsLoading(false));
    }, [apiClient]);

    return (
        <div className="bg-white p-4 sm:p-8 rounded-lg shadow">
            <PageHeader title="Transactions" description="Every deal file: open one for its parties, milestones, documents and compliance." />

            {isLoading && <p>Loading transactions...</p>}
            {error && <p className="text-red-500">{error}</p>}
            {!isLoading && !error && (
                <DataList rows={transactions} rowKey="transaction_id" csvName="transactions" defaultSort={{ key: 'transaction_id', dir: 'desc' }}
                    filters={[{ key: 'status', label: 'Status' }, { key: 'agent_name', label: 'Agent' }]}
                    columns={[
                        { key: 'transaction_id', label: '#', type: 'number' },
                        { key: 'street_address', label: 'Property', render: (t) => <Link to={`/dashboard/transactions/${t.transaction_id}`} className="text-indigo-700 font-medium">{t.street_address}</Link> },
                        { key: 'transaction_type', label: 'Type' },
                        { key: 'buyer_name', label: 'Buyer' },
                        { key: 'seller_name', label: 'Seller' },
                        { key: 'agent_name', label: 'Agent' },
                        { key: 'status', label: 'Status' },
                        { key: 'projected_close_date', label: 'Closing', type: 'date' },
                        { key: 'actions', label: '', sortable: false, csv: false, search: false, render: (t) => <Link to={`/dashboard/transactions/${t.transaction_id}`} className="text-indigo-600 hover:text-indigo-900">Details</Link> },
                    ]} />
            )}
        </div>
    );
};

export default TransactionListPage;